import { render, staticRenderFns } from "./PlayerPainWidget.vue?vue&type=template&id=eb434e62"
import script from "./PlayerPainWidget.vue?vue&type=script&lang=js"
export * from "./PlayerPainWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports